var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSheets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10 2q-.16 0-.32.06L1.14 5.94q-.28.15 0 .3l8.54 3.88a.8.8 0 0 0 .64 0l8.54-3.88q.29-.15 0-.3l-8.54-3.88A1 1 0 0 0 10 2m0 1.42 5.88 2.67L10 8.76 4.12 6.1zM2.27 8.44 1.14 9q-.29.17 0 .32l8.54 4.2a.8.8 0 0 0 .64 0l8.54-4.2q.29-.17 0-.32l-1.13-.56-7.41 3.65a.8.8 0 0 1-.64 0zm0 3.41-1.13.56c-.19.09-.19.23 0 .32l8.54 4.2a.8.8 0 0 0 .64 0l8.54-4.2q.29-.17 0-.32l-1.13-.56-7.41 3.65a.8.8 0 0 1-.64 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSheets);
export default ForwardRef;